import * as d3 from 'd3'
export default {
  methods: {

    innerSvg_Overall(data) {
      
      this.dashboard.filter(f=> !f.type).forEach(d=> {
        if(d.id == 'SUM-SYS' || d.id == 'SUM-DESC') d3.select(`#${d.id}`).text(data[d.code])
        else {
          d3.select(`#${d.id}`).attr('text-anchor', 'end')
          .style('fill', data[d.code] == 0 ? '#bcbcbc' : '#333')
          .text(data[d.code])
          .call(this.event_Link, data, d.code, d.req, d.filter)
        }
      })
      d3.select(`#BAR-B`).attr('rx', 5).attr('ry', 5).attr('width', data.B_PRO*2.5)

      // Progress BAR
      this.dashboard.filter(f=> f.type).forEach(d=> {

        if(d.type=='PRO') {
          let x = this.innerSVG.dashboard.pro + Number(data[d.code])
          d3.select(`#${d.id}`).transition().duration(500)
          .attr('x', data[d.code] < 70 ? x+2 : x-2)
          .attr('text-anchor', data[d.code] < 70 ? 'start' : 'end')
          .text(data[d.code]+'%')
        }

        if(d.type=='BAR') {
          d3.select(`#${d.id}`).transition().duration(500)
          .attr('width', data[d.code])
        }

      })

    },


    innerSvg_ITRs(data) {
      
      this.itrs.filter(f=> !f.type).forEach(d=> {
        d3.select(`#${d.id}`).attr('text-anchor', 'end')
        .style('fill', data[d.code] == 0 ? '#bcbcbc' : '#333')
        .text(data[d.code])
        .call(this.event_Link, data, d.code, d.req, d.filter)
      })

      // Progress BAR
      this.itrs.filter(f=> f.type).forEach(d=> {
        if(d.type=='PRO') {
          let x = this.innerSVG.dashboard.pro + Number(data[d.code])
          d3.select(`#${d.id}`)
          .attr('x', data[d.code] < 70 ? x+2 : x-2)
          .attr('text-anchor', data[d.code] < 70 ? 'start' : 'end')
          .text(data[d.code]+'%')
        }
        if(d.type=='BAR') {
          d3.select(`#${d.id}`).attr('width', data[d.code])
        }
      })

    },

  }
}